/* Header behaviour: desktop dropdowns (hover, click, Esc), the mobile drawer
   (focus trap, Esc, scroll lock, aria-expanded) and the bag count.
   Markup: sections/wulf-header.liquid. Styles: assets/msc-chrome.css. */
(function () {
  if (window.__mscChrome) return;
  window.__mscChrome = true;

  var FOCUSABLE = 'a[href], button:not([disabled]), input:not([disabled]):not([type="hidden"]), [tabindex]:not([tabindex="-1"])';

  function ready(fn) {
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', fn);
    else fn();
  }

  /* ---------------------------------------------------------- dropdowns */
  function initDropdowns() {
    var items = document.querySelectorAll('[data-msc-item].has-dd');
    var hoverTimer;

    function setOpen(item, open) {
      var toggle = item.querySelector('[data-msc-toggle]');
      item.classList.toggle('is-open', open);
      if (toggle) toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
    }
    function closeAll(except) {
      items.forEach(function (it) { if (it !== except) setOpen(it, false); });
    }

    items.forEach(function (item) {
      var toggle = item.querySelector('[data-msc-toggle]');
      if (!toggle) return;

      toggle.addEventListener('click', function () {
        var open = !item.classList.contains('is-open');
        closeAll(item);
        setOpen(item, open);
      });

      /* hover, for mouse pointers only (touch uses the toggle) */
      item.addEventListener('pointerenter', function (e) {
        if (e.pointerType !== 'mouse') return;
        clearTimeout(hoverTimer);
        closeAll(item);
        setOpen(item, true);
      });
      item.addEventListener('pointerleave', function (e) {
        if (e.pointerType !== 'mouse') return;
        hoverTimer = setTimeout(function () { setOpen(item, false); }, 120);
      });

      /* leaving with the keyboard closes it */
      item.addEventListener('focusout', function (e) {
        if (!item.contains(e.relatedTarget)) setOpen(item, false);
      });
      item.addEventListener('keydown', function (e) {
        if (e.key === 'Escape' && item.classList.contains('is-open')) {
          setOpen(item, false);
          toggle.focus();
          e.stopPropagation();
        }
      });
    });

    document.addEventListener('click', function (e) {
      if (!e.target.closest('[data-msc-item]')) closeAll();
    });
  }

  /* ------------------------------------------------------------- drawer */
  function initDrawer() {
    var drawer = document.querySelector('[data-msc-drawer]');
    var opener = document.querySelector('[data-msc-open]');
    if (!drawer || !opener) return;
    var closer = drawer.querySelector('[data-msc-close]');
    var isOpen = false;
    var closeTimer;
    var inertTargets = [];

    function focusables() {
      return Array.prototype.filter.call(drawer.querySelectorAll(FOCUSABLE), function (el) {
        return el.offsetParent !== null || el === document.activeElement;
      });
    }

    function setInert(on) {
      if (on) {
        /* everything outside the header (page content) becomes unreachable */
        inertTargets = Array.prototype.filter.call(document.body.children, function (el) {
          return !el.contains(drawer) && el.tagName !== 'SCRIPT' && !el.hasAttribute('inert');
        });
        inertTargets.forEach(function (el) { el.setAttribute('inert', ''); });
      } else {
        inertTargets.forEach(function (el) { el.removeAttribute('inert'); });
        inertTargets = [];
      }
    }

    function open() {
      if (isOpen) return;
      isOpen = true;
      clearTimeout(closeTimer);
      drawer.hidden = false;
      void drawer.offsetWidth; /* reflow so the transition runs */
      drawer.classList.add('is-open');
      opener.setAttribute('aria-expanded', 'true');
      document.documentElement.classList.add('msc-lock');
      setInert(true);
      var f = focusables();
      if (closer) closer.focus(); else if (f[0]) f[0].focus();
    }

    function close(returnFocus) {
      if (!isOpen) return;
      isOpen = false;
      drawer.classList.remove('is-open');
      opener.setAttribute('aria-expanded', 'false');
      document.documentElement.classList.remove('msc-lock');
      setInert(false);
      closeTimer = setTimeout(function () { if (!isOpen) drawer.hidden = true; }, 320);
      if (returnFocus !== false) opener.focus();
    }

    opener.addEventListener('click', open);
    if (closer) closer.addEventListener('click', function () { close(); });

    drawer.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') { e.preventDefault(); close(); return; }
      if (e.key !== 'Tab') return;
      var f = focusables();
      if (!f.length) return;
      var first = f[0], last = f[f.length - 1];
      if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
    });

    /* expandable menu items */
    drawer.querySelectorAll('[data-msc-expand]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var panel = document.getElementById(btn.getAttribute('aria-controls'));
        var expand = btn.getAttribute('aria-expanded') !== 'true';
        btn.setAttribute('aria-expanded', expand ? 'true' : 'false');
        if (panel) panel.hidden = !expand;
      });
    });

    /* growing the window past the breakpoint closes it */
    if (window.matchMedia) {
      var mq = window.matchMedia('(min-width: 981px)');
      var onChange = function (e) { if (e.matches) close(false); };
      if (mq.addEventListener) mq.addEventListener('change', onChange);
      else if (mq.addListener) mq.addListener(onChange);
    }
  }

  /* ---------------------------------------------------------- bag count */
  function setCount(n) {
    n = Number(n) || 0;
    var link = document.getElementById('cart-icon-bubble');
    if (!link) return;
    var badge = link.querySelector('[data-msc-count]');
    var label = link.querySelector('[data-msc-bag-label]');
    if (!badge) {
      badge = document.createElement('span');
      badge.className = 'msc-hdr__count';
      badge.setAttribute('data-msc-count', '');
      badge.setAttribute('aria-hidden', 'true');
      link.appendChild(badge);
    }
    badge.textContent = n > 99 ? '99+' : String(n);
    badge.hidden = n === 0;
    if (label) label.textContent = n > 0 ? 'Bag, ' + n + (n === 1 ? ' item' : ' items') : 'Bag';
  }

  document.addEventListener('msc:cart-updated', function (e) {
    if (e && e.detail && typeof e.detail.itemCount !== 'undefined') setCount(e.detail.itemCount);
  });

  /* Dawn publishes cart changes on its pub/sub; its own JS also swaps in the
     cart-icon-bubble section, this keeps the count right in between. */
  function subscribeDawn() {
    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined' && PUB_SUB_EVENTS.cartUpdate) {
      subscribe(PUB_SUB_EVENTS.cartUpdate, function (state) {
        var cart = state && state.cartData;
        if (cart && typeof cart.item_count !== 'undefined') setCount(cart.item_count);
      });
    }
  }

  ready(function () {
    initDropdowns();
    initDrawer();
    subscribeDawn();
  });
})();
